<template>
  <div>
    <component
      v-if="currentComponent"
      :is="currentComponent"
      :data.sync="data"
      :config="config"
      @update:data="onDataUpdated"
    />
  </div>
</template>

<script>
import configComponentMap from './configComponentMap';

export default {
  components: {
  },
  props: {
    fieldTypeCfg: Object,
    config: Object,
  },
  data() {
    return {
      data: {},
    };
  },
  async created() {
    this.data = JSON.parse(JSON.stringify(this.fieldTypeCfg || {}));
  },
  methods: {
    onDataUpdated(newData) {
      if(!newData) return;
      this.data = newData;
      this.$emit("update:data", this.data);
    },
  },
  watch: {
    data: {
      handler(val) {
        this.$emit("update:data", val);
      },
      deep: true,
    },
  },
  computed: {
    currentComponent() {
      return configComponentMap[this.config.type] || null
    }
  }
};
</script>

<style></style>
